module.exports = __webpack_public_path__ + "static/Miameee-4080355cffba8d2cd79bf7dc0e7dab05.png";